import { useSelector } from "react-redux";

import urls from "@/constants/Urls";
import HeaderCard from "@/design/components/HeaderCard";
import FormGroup from "@/design/forms/FormGroup";
import { saveSetting } from "@/utils/utility";
import Valkyrie, { viArrowUpRightFromSquare, viChartPie } from "@sippy-platform/valkyrie";

import { Box, Button, Grid, Link, List, ListItemIcon, ListItemText, Stack, Switch } from "@mui/material";

import SettingsOption from "./components/SettingsOption";

export default function Privacy() {
  const settings = useSelector((state) => state.auth.settings);

  const handleTracking = () => {
    saveSetting("tracking", settings.tracking === 0 ? 1 : 0);
  };

  return (
    <Stack spacing={2}>
      <HeaderCard title="Privacy" sx={{ ".MuiCardHeader-title": { my: 0 } }} />
      <FormGroup title="Telemetry">
        <Grid size={12}>
          <List>
            <SettingsOption onClick={handleTracking}>
              <ListItemIcon>
                <Valkyrie icon={viChartPie} />
              </ListItemIcon>
              <ListItemText primary="Allow usage tracking" />
              <Box sx={{ p: 0, justifyContent: "flex-end", pl: 1 }}>
                <Switch checked={!!settings.tracking || false} sx={{ m: 0, mt: -0.5 }} />
              </Box>
            </SettingsOption>
          </List>
        </Grid>
      </FormGroup>
      <Stack
        direction="row"
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Button
          component={Link}
          href={`${urls.docs}docs/start/settings#privacy`}
          target="_blank"
          startIcon={<Valkyrie icon={viArrowUpRightFromSquare} />}
          size="small"
          color="inherit"
        >
          More about telemetry
        </Button>
      </Stack>
    </Stack>
  );
}
